import TagManager from 'react-gtm-module'

import { Roles } from 'src/Constants/enums'
import { ID } from 'src/Types/common'

import { EventNameEnum, EventTypeEnum } from '../tagManagerEnums'

export const notificationClickEvent = ({
  userId,
  accountType,
}: {
  userId?: ID | null
  accountType: Roles
}): void => {
  TagManager.dataLayer({
    dataLayer: {
      event: EventTypeEnum.GA_EVENT,
      event_params: {
        event_name: EventNameEnum.NotificationClick,
      },
      user_properties: {
        ...(userId ? { user_id: userId } : {}),
        account_type: accountType,
      },
    },
  })
}
